import { Injectable } from '@angular/core';
import {
  CanActivate,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Router } from '@angular/router';
import { AccessService } from '../services/access.service';
import { Observable, of, switchMap } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private accessService: AccessService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this._check('/auth/login');
  }

  private _check(redirectURL: any): Observable<boolean> {
    // Check the authentication status
    return this.accessService.check().pipe(
      switchMap((authenticated: boolean) => {
        if (!authenticated) {
          this.router.navigate([redirectURL]);
          return of(false);
        }
        return of(true);
      })
    );
  }
}
